import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import styles from "./MassMailing.module.css";
import { formatDate, formatTime } from "../../utils/const";

const JobCard = (props) => {
  const {
    jobId,
    jobTitle,
    experience,
    visa,
    rate,
    date,
    location,
    requirement,
    handleShowJob,
    setJObID,
  } = props;

  const handleOnClickMassMail = (requirement) => {
    handleShowJob();
    setJObID(requirement);
  };

  return (
    <Box className={styles.jobcardStyle}>
      <Box>
        <Typography>{jobId}</Typography>
        <Typography>
          {jobTitle}, Must Have {experience} {experience > 1 ? "Years" : "Year"}
        </Typography>
        <Typography>{location}</Typography>
        <Typography>{visa}</Typography>
        <Typography>
          {requirement?.client_name !== ""
            ? `${requirement?.client_name},`
            : ""}{" "}
          ${rate}
          {rate > 0
            ? requirement?.requirement_type?.includes("full_Time")
              ? "K Yearly"
              : " Hourly"
            : "Non Disclosed"}{" "}
        </Typography>
      </Box>

      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "end" }}>
        <Typography>{`${formatDate(date)}, ${formatTime(date)}`}</Typography>
        <button onClick={() => handleOnClickMassMail(requirement)}>
          Mass Mail
        </button>
      </Box>
    </Box>
  );
};

export default JobCard;
